module.exports = __webpack_public_path__ + "media/images/icon_minus_green-3faff2bdc41db3302b5dd4f66b7c4f10.svg";